import { Component, OnInit } from '@angular/core';
import { EntregaEquipoLinkService } from 'src/app/pages/services/entrega-equipo-link.service';
import { EntregaEquipoLink, EquipoAsignado } from 'src/app/shared/models/entrega-equipo-link.interface';

@Component({
  selector: 'app-main-entrega-equipos',
  templateUrl: './main-entrega-equipos.component.html',
  styleUrls: ['./main-entrega-equipos.component.css']
})
export class MainEntregaEquiposComponent implements OnInit {

  pendientes: EntregaEquipoLink[] = [];
  asignados: EquipoAsignado[] = [];
  conflictos: any[] = [];

  constructor(
    private entregaEquipoLinkService: EntregaEquipoLinkService
  ) { }

  ngOnInit(): void {
    this.actualizarTabla();
  }

  actualizarTabla(event?: boolean) {
    this.entregaEquipoLinkService.listarPendientes().subscribe(res => {
      this.pendientes = res.data || [];
    });
    this.entregaEquipoLinkService.listarEquiposAsignados().subscribe(res => {
      this.asignados = res.data || [];
    });
    this.entregaEquipoLinkService.listarConflictosEquipos().subscribe(res => {
      this.conflictos = res.data || [];
    });
  }

}
